"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.settings.systemCommunicationLabel': '系统通信',
    'whatsapp.settings.systemCommunicationHint': '启用后，此机器人将用作默认系统通信通道。一次只能有一个机器人担任此角色。',
    'whatsapp.settings.systemCommunicationGroupLabel': '机器人到管理员通信群组',
    'whatsapp.settings.systemCommunicationGroupHint': '选择机器人用于向管理员发送系统消息的群组。在系统通信启用时使用。',
    'whatsapp.settings.selectGroup': '选择群组',
    'whatsapp.settings.title': '通讯',
    'whatsapp.settings.description': '通过二维码登录连接和管理您的 WhatsApp 账户。',
    'whatsapp.settings.status': '连接状态',
    'whatsapp.settings.statusConnected': '已连接',
    'whatsapp.settings.statusDisconnected': '未连接',
    'whatsapp.settings.entityLabel': '实体 ID',
    'whatsapp.settings.logout': '退出登录',
    'whatsapp.settings.entityIdLabel': '实体 ID（电话号码或标识符）',
    'whatsapp.settings.entityIdPlaceholder': '输入电话号码或实体 ID',
    'whatsapp.settings.startLogin': '开始登录',
    'whatsapp.settings.qrTitle': '二维码',
    'whatsapp.settings.qrInstruction': '打开手机上的 WhatsApp > 设置 > 已关联的设备 > 关联设备 > 扫描此二维码。',
    'whatsapp.settings.logsTitle': '连接日志',
    'whatsapp.settings.clearLogs': '清除',
    'whatsapp.settings.noLogs': '暂无日志。开始登录流程以查看连接日志。',
    'whatsapp.settings.noSettings': '尚无电话号码配置。请先创建一个。',
    'whatsapp.settings.creator': '创建者',
    'whatsapp.settings.pinMessageLabel': '置顶消息',
    'whatsapp.settings.pinMessagePlaceholder': '要在对话中置顶的消息内容',
    'whatsapp.settings.pinMessageHint': '如果填写，此消息将为该号码置顶。',
    'whatsapp.settings.pingerLabel': '心跳保活',
    'whatsapp.settings.pingerHint': '启用后，此机器人会定期发送心跳消息以保持连接活跃。',
    'whatsapp.settings.phoneTitle': '电话号码设置',
    'whatsapp.settings.formTitle': 'WhatsApp 配置',
    'whatsapp.settings.phoneLabel': '电话号码',
    'whatsapp.settings.titleLabel': '标题',
    'whatsapp.settings.titlePlaceholder': '如：主账号、支持线路…',
    'whatsapp.settings.phonePlaceholder': '输入电话号码（例如 +86123456789）',
    'whatsapp.settings.phoneHint': '输入在 WhatsApp 注册的电话号码，包括国家代码。',
    'whatsapp.settings.reportEmailLabel': '报告邮箱',
    'whatsapp.settings.reportEmailTagsPlaceholder': '添加邮箱地址...',
    'whatsapp.settings.reportEmailTagsHint': '输入邮箱地址并按 Enter 键添加。可添加多个地址，摘要将发送至所有地址。',
    'whatsapp.settings.reportEmailPlaceholder': '输入用于摘要报告的邮箱',
    'whatsapp.settings.reportEmailHint': '群聊摘要将发送到此邮箱地址。',
    'whatsapp.settings.languageLabel': '机器人语言',
    'whatsapp.settings.languageHint': '机器人回复消息和生成摘要时使用的语言。',
    'whatsapp.settings.communicationTypeLabel': '通信类型',
    'whatsapp.settings.communicationTypeHint': '选择此机器人使用的通信渠道。',
    'whatsapp.settings.communicationType.wa': 'WhatsApp',
    'whatsapp.settings.communicationType.tele': 'Telegram',
    'whatsapp.settings.apiIdLabel': 'Telegram API-ID',
    'whatsapp.settings.apiIdPlaceholder': '输入 Telegram API-ID',
    'whatsapp.settings.apiIdHint': '从 my.telegram.org 获取的数字 API-ID。',
    'whatsapp.settings.apiHashLabel': 'Telegram API-Hash',
    'whatsapp.settings.apiHashPlaceholder': '输入 Telegram API-Hash',
    'whatsapp.settings.apiHashHint': '从 my.telegram.org 获取的 API-Hash 字符串。',
    'whatsapp.settings.telegramApiLink': '获取 Telegram 账户的 API ID 和 Hash',
    'whatsapp.settings.botResponseConditionLabel': '机器人响应条件',
    'whatsapp.settings.botResponseConditionPlaceholder': '描述机器人应该何时响应，例如“关于营业时间、价格或服务的问题”',
    'whatsapp.settings.botResponseConditionHint': '机器人将回复与此条件匹配的用户消息。留空以禁用自动回复。',
    'whatsapp.settings.avatarLabel': '头像',
    'whatsapp.settings.selectAvatar': '-- 选择头像 --',
    'whatsapp.settings.avatarHint': '选择一个头像用于此WhatsApp号码的AI回复。',
    'whatsapp.settings.save': '保存设置',
    'whatsapp.settings.startAgent': '启动代理',
    'whatsapp.settings.stopAgent': '停止代理',
    'whatsapp.settings.agentRunning': '代理运行中',
    'whatsapp.settings.agentInitializing': '初始化中...',
    'whatsapp.settings.agent_status_active': '活跃',
    'whatsapp.settings.agent_status_initializing': '初始化中',
    'whatsapp.settings.agent_status_inactive': '不活跃',
    'whatsapp.settings.telegramAuthTitle': 'Telegram 身份验证',
    'whatsapp.settings.telegramCodeInstruction': '请输入发送到您 Telegram 账户的验证码。',
    'whatsapp.settings.telegramCodePlaceholder': '验证码',
    'whatsapp.settings.telegramCodeSubmit': '提交验证码',
    'whatsapp.settings.telegramPasswordInstruction': '请输入您的 Telegram 两步验证密码。',
    'whatsapp.settings.telegramPasswordPlaceholder': '密码',
    'whatsapp.settings.telegramPasswordSubmit': '提交密码',
    'whatsapp.settings.pop3.title': '电子邮件服务器',
    'whatsapp.settings.pop3.description': '配置电子邮件服务器以获取和监控邮件。',
    'whatsapp.settings.pop3.add': '添加服务器',
    'whatsapp.settings.pop3.empty': '未配置邮件服务器。点击"添加服务器"创建新服务器。',
    'whatsapp.settings.pop3.untitled': '未命名服务器',
    'whatsapp.settings.pop3.host.label': '服务器主机',
    'whatsapp.settings.pop3.host.placeholder': 'pop.example.com',
    'whatsapp.settings.pop3.port.label': '端口',
    'whatsapp.settings.pop3.port.placeholder': '995',
    'whatsapp.settings.pop3.username.label': '用户名',
    'whatsapp.settings.pop3.username.placeholder': '输入邮箱或用户名',
    'whatsapp.settings.pop3.password.label': '密码',
    'whatsapp.settings.pop3.password.placeholder': '输入密码',
    'whatsapp.settings.pop3.useTls.label': '使用 TLS/SSL',
    'whatsapp.settings.pop3.enabled.label': '已启用',
    'whatsapp.settings.pop3.save': '保存邮件设置',
    'whatsapp.settings.pop3.configure': '配置邮件',
    'whatsapp.settings.pop3.enabled.yes': '已启用',
    'whatsapp.settings.pop3.enabled.no': '已禁用',
    'whatsapp.settings.pop3.actions': '操作',
    'whatsapp.settings.pop3.remove': '删除',
    'whatsapp.settings.pop3.remove.failed': '删除邮件账户失败。',
    'whatsapp.settings.pop3.removed': '邮件账户删除成功。',
    'whatsapp.settings.pop3.saved': '邮件设置保存成功。',
    'whatsapp.settings.pop3.host.required': '服务器主机为必填项。',
    'whatsapp.settings.pop3.remove.confirm': '您确定要删除此电子邮件账户吗？',
    'whatsapp.settings.pop3.isGmail.label': 'Gmail',
    'whatsapp.settings.pop3.isGmail.hint': '启用以通过OAuth连接您的Gmail账户。',
    'whatsapp.settings.pop3.gmail.info': '点击"连接Gmail"以授权读取邮件的权限。',
    'whatsapp.settings.pop3.gmail.connect': '连接Gmail',
    'whatsapp.settings.pop3.gmail.connecting': '连接中...',
    'whatsapp.settings.pop3.gmail.connected': 'Gmail已连接',
    'whatsapp.settings.pop3.gmail.notConnected': 'Gmail未连接',
    'whatsapp.settings.pop3.gmail.disconnect': '断开Gmail',
    'whatsapp.settings.pop3.gmail.authSuccess': 'Gmail连接成功。',
    'whatsapp.settings.pop3.gmail.authFailed': '无法连接Gmail。',
    'whatsapp.settings.pop3.gmail.disconnectSuccess': 'Gmail断开连接成功。',
    'whatsapp.settings.pop3.gmail.disconnectFailed': '无法断开Gmail连接。',
};
